import { render, staticRenderFns } from "./ArticleMobile.vue?vue&type=template&id=4e5461a7&scoped=true"
import script from "./ArticleMobile.vue?vue&type=script&lang=js"
export * from "./ArticleMobile.vue?vue&type=script&lang=js"
import style0 from "./ArticleMobile.vue?vue&type=style&index=0&id=4e5461a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5461a7",
  null
  
)

export default component.exports